// This file was auto-generated by __GENERATE_CHAIN_PRESETS__.js. Do not edit manually.

import { bitkub as _bitkub } from 'viem/chains'
import { createCommon } from '../createCommon.js'

/**
 * Creates a common configuration for the bitkub chain.
 * @type {import('../Common.js').Common}
 * @description
 * Chain ID: 96
 * Chain Name: Bitkub
 * Default Block Explorer: https://www.bkcscan.com
 * Default RPC URL: https://rpc.bitkubchain.io
 * @example
 * import { createMemoryClient } from 'tevm'
 * import { bitkub } from 'tevm/common'
 * import { http } from 'tevm'
 *
 * const client = createMemoryClient({
 *   common: bitkub,
 *   fork: {
 *     transport: http({ url: 'https://example.com' })({})
 *   },
 * })
 */
export const bitkub = createCommon({
	..._bitkub,
	loggingLevel: 'warn',
	eips: [],
	hardfork: 'prague',
})
